import React from 'react'
import {ProfilePage} from "./ProfilePage";
import {UploadImage} from "../../../components/common/uploadImage/UploadImage";
import {useFormik} from "formik";
import {useAuth} from "../../../modules/auth";
import {updateAvatar, updateProfile} from "../../../services/authSvc";
import {useNotification} from "../../../context/NotificationContext";
import {getUserByToken} from "../../../modules/auth/core/_requests";

export const ProfileOverviewTab = () => {
  const {currentUser, setCurrentUser} = useAuth()
  const {showNotification} = useNotification()

  const formik = useFormik({
    initialValues: {
      first_name: currentUser?.first_name || "",
      last_name: currentUser?.last_name || ""
    },
    onSubmit: async (values) => {
      const formData = new FormData()
      formData.append('first_name', values.first_name)
      formData.append('last_name', values.last_name)
      try {
        const res = await updateProfile(formData)
        if (res?.success) {
          showNotification("Muvaffaqiyatli", "Ma'lumotlar yangilandi", "success")
          const {data} = await getUserByToken()
          if (data) {
            setCurrentUser(data.data)
          }
        }
      } catch (e: any) {
        showNotification("Xatolik", e?.data?.data?.detail || e?.data?.data?.data?.detail || "Ma'lumotlar yangilanmadi", "error")
      }
    }
  })

  const handleAvatarChange = async (file: File) => {
    if (file) {
      const formData = new FormData()
      formData.append('avatar', file)
      await updateAvatar(formData)
      const {data} = await getUserByToken()
      if (data) {
        setCurrentUser(data.data)
      }
    }
  }

  return (
      <ProfilePage>
        <div className="card mb-5 mb-xl-10">
          <div className="card-header border-0 cursor-pointer" role="button" data-bs-toggle="collapse"
               data-bs-target="#kt_account_profile_details" aria-expanded="true"
               aria-controls="kt_account_profile_details">
            <div className="card-title m-0"><h3 className="fw-bolder m-0">Umumiy ma'lumotlar</h3></div>
          </div>
          <div id="kt_account_profile_details" className="collapse show">
            <form onSubmit={formik.handleSubmit} className="form">
              <div className="card-body border-top p-9">
                <div className="row mb-6">
                  <label className="col-lg-4 col-form-label fw-bold fs-6">Avatar</label>
                  <div className="col-lg-8">
                    <UploadImage imageSizes={"avatar"} onImageRemove={() => {
                      formik.setFieldValue('avatar', null);
                    }} defaultImage={
                      currentUser?.avatar
                    } onImageUpload={async (file) => {
                      file && await handleAvatarChange(file)
                    }}/>
                  </div>
                </div>
                <div className="row mb-6"><label className="col-lg-4 col-form-label required fw-bold fs-6">Ism,
                  familiya</label>
                  <div className="col-lg-8">
                    <div className="row">
                      <div className="col-lg-6 fv-row"><input type="text"
                                                              className="form-control form-control-lg form-control-solid mb-3 mb-lg-0"
                                                              placeholder="Ism" name="first_name"
                                                              value={
                                                                formik.values.first_name
                                                              }
                                                              onBlur={
                                                                formik.handleBlur
                                                              }
                                                              onChange={
                                                                formik.handleChange
                                                              }/>
                      </div>
                      <div className="col-lg-6 fv-row"><input type="text"
                                                              className="form-control form-control-lg form-control-solid"
                                                              placeholder="Familiya" name="last_name" onBlur={
                        formik.handleBlur
                      } value={
                        formik.values.last_name
                      } onChange={
                        formik.handleChange
                      }/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer d-flex justify-content-end py-6 px-9">
                <button disabled={formik.isSubmitting} type="submit" className="btn btn-primary">
                  {
                    formik.isSubmitting ? "Yangilanmoqda..." : "Yangilash"
                  }
                </button>
              </div>
            </form>
          </div>
        </div>
      </ProfilePage>
  )
}
